import React from "react";
import DynamicButton from "../../../components/DynamicButton/DynamicButton";
import DynamicInput from "../../../components/DynamicInput/DynamicInput";
import DynamicSelect from "../../../components/DynamicSelect/DynamicSelect";
import { ProfileIcon } from "../../../components/ProfileIcon/ProfileIcon";

const Step2 = ({
  state,
  errors,
  validateStep,
  handleChange,
  companyTypes = [],
  decrementStep,
}) => {
  return (
    <>
      <ProfileIcon
        style={{
          marginTop: "18px",
        }}
        height="60px"
        width="60px"
      />
      <p
        style={{
          color: "white",
          fontSize: "14px",
          margin: "20px 1.66667em",
          textAlign: "center",
        }}
      >
        Company Details
      </p>
      <div style={{ margin: "17px 0" }}>
        <DynamicInput
          name="companyName"
          placeholder="Organization Name"
          style={{ width: "100%" }}
          value={state.companyName}
          onChange={(e) => {
            handleChange("companyName", e.target.value);
          }}
          error={errors.companyNameError}
        />
      </div>
      <div style={{ margin: "17px 0 22px 0" }}>
        <DynamicSelect
          name="companyType"
          placeholder="Organization Type"
          value={state.companyType}
          onChange={(e) => {
            handleChange("companyType", e.target.value);
          }}
          error={errors.companyTypeError}
          options={companyTypes}
        />
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          width: "100%",
        }}
      >
        <DynamicButton
          style={{ marginBottom: "22px" }}
          onClick={(e) => validateStep(e)}
        >
          Continue
        </DynamicButton>
        <DynamicButton
          style={{ marginLeft: 0, backgroundColor: "#000" }}
          onClick={(e) => decrementStep(e)}
        >
          Back
        </DynamicButton>
      </div>
    </>
  );
};

export default Step2;
